import { FileInfo } from "@classes/file/fileInfo";

export class AddOrderDocumentRequest {
    public fileInfo: FileInfo;
    public fileName: string;

    public constructor(fileInfo: FileInfo, fileName: string) {
        this.fileInfo = fileInfo;
        this.fileName = fileName;
    }
}